//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { Draggable } from "vue-smooth-dnd";

import { mapGetters, mapActions } from "vuex";
import sharedMethods from "../sharedMethods.js";
import EditMediaModal from "./Media/EditMediaModals/EditMediaModal";

export default {
  name: "playlist-card",
  props: ["content", "index", "playlist"],

  components: { Draggable, EditMediaModal },
  computed: {
    ...mapGetters(["getMediaFilesForPlaylist"]),
  },
  data() {
    return {
      info: [],
      url: this.$store.getters.getHost + "content/",
      filename: "",
      host: "",
      api: "",
      accID: this.$store.getters.getUser.AccID,
      showEditMediaModal: false,
    };
  },

  methods: {
    ...mapActions(["updatePlaylistContentV2", "updateCurrentSelectedPlaylistItems"]),
    removePlItem() {
      let playlistContent = this.getMediaFilesForPlaylist(this.playlist);

      // remove element
      playlistContent.splice(this.index, 1);

      // get only the content ids of the new playlist
      let contentIds = [];
      playlistContent.forEach((content) => {
        if (content.contentGroupId) {
          contentIds.push(content.contentGroupId);
        } else {
          contentIds.push(content.id);
        }
      });

      // update db with new content ids
      this.updatePlaylistContentV2({
        content: contentIds,
        playlistId: this.playlist.ID,
      }).then(() => {
        sharedMethods.successNotify("Playlist saved");
      });
    },
  },
};
